module.exports = __webpack_public_path__ + "567678cfd0a51220933a5b5b62aeae11.svg";